import React, { useState, useEffect } from 'react';
import { progressService, gamificationService } from '../../services/firestoreService';
import './ProgressDashboard.css';

const ProgressDashboard = ({ studentId, sessionId }) => {
  const [progress, setProgress] = useState({
    totalPoints: 0,
    attendanceStreak: 0,
    sessionAttendanceCount: 0,
    badges: []
  });
  const [pointsHistory, setPointsHistory] = useState([]);

  useEffect(() => {
    // Load progress
    progressService.getStudentProgress(studentId, sessionId).then(setProgress);

    // Subscribe to progress updates
    const unsubscribe = progressService.subscribeToStudentProgress(studentId, (data) => {
      setProgress(prev => ({ ...prev, ...data }));
    });

    // Load points history
    gamificationService.getPointsHistory(studentId, 20).then(setPointsHistory);

    return () => unsubscribe();
  }, [studentId, sessionId]);

  return (
    <div className="progress-dashboard-container">
      <h2>📈 My Progress</h2>

      <div className="progress-stats">
        <div className="stat-card points-card">
          <div className="stat-icon">⭐</div>
          <div className="stat-info">
            <div className="stat-value">{progress.totalPoints.toLocaleString()}</div>
            <div className="stat-label">Total Points</div>
          </div>
        </div>

        <div className="stat-card streak-card">
          <div className="stat-icon">🔥</div>
          <div className="stat-info">
            <div className="stat-value">{progress.attendanceStreak}</div>
            <div className="stat-label">Day Streak</div>
          </div>
        </div>

        <div className="stat-card attendance-card">
          <div className="stat-icon">📅</div>
          <div className="stat-info">
            <div className="stat-value">{progress.sessionAttendanceCount}</div>
            <div className="stat-label">Classes Attended</div>
          </div>
        </div>
      </div>

      <div className="badges-section">
        <h3>🏆 Badges Earned</h3>
        {progress.badges.length === 0 ? (
          <p className="no-badges">No badges yet. Keep participating to earn badges!</p>
        ) : (
          <div className="badges-grid">
            {progress.badges.map((badge) => (
              <div key={badge.id} className="badge-card">
                <div className="badge-icon-large">{badge.badgeIcon}</div>
                <div className="badge-name">{badge.badgeName}</div>
                <div className="badge-description">{badge.description}</div>
              </div>
            ))}
          </div>
        )}
      </div>

      <div className="points-history-section">
        <h3>📊 Recent Points</h3>
        {pointsHistory.length === 0 ? (
          <p className="no-history">No points history yet.</p>
        ) : (
          <div className="points-history-list">
            {pointsHistory.map((point) => (
              <div key={point.id} className="point-item">
                <div className="point-details">
                  <span className="point-reason">{point.reason}</span>
                  <span className="point-date">
                    {new Date(point.awardedAt).toLocaleDateString()}
                  </span>
                </div>
                <div className="point-value">+{point.points}</div>
              </div>
            ))}
          </div>
        )}
      </div>
    </div>
  );
};

export default ProgressDashboard;

